import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabsforcorporatepicnicinpune() {



const cardData =
  {
    keyword: 'Cabs for Corporate Picnic in Pune',
    heading: 'Sanavi Travels: Cabs for Corporate Picnic in Pune',
    headingDescription: 'Sanavi Travels offers well-organized, comfortable, and reliable Cabs for Corporate Picnic in Pune, specially designed for companies planning team outings, office picnics, employee engagement activities, annual get-togethers, and corporate leisure events. Corporate picnics are an important part of team bonding, stress relief, and workplace morale, and smooth transportation plays a vital role in the success of such outings. Our corporate picnic cab services in Pune ensure that employees and management travel together safely, comfortably, and on schedule to picnic destinations, resorts, hill stations, adventure parks, and outdoor venues around Pune. Sanavi Travels provides AC and Non-AC sedans, SUVs, and larger vehicles based on group size, all driven by experienced and courteous chauffeurs who prioritize safety, punctuality, and smooth driving. With ample luggage space, comfortable seating, flexible pickup points, and return scheduling, our picnic cab services eliminate travel-related stress and allow teams to fully enjoy their outing. We support half-day, full-day, and custom picnic packages with transparent pricing, no hidden charges, dedicated coordination, and 24/7 support. Whether it is a small office outing or a large corporate picnic involving multiple teams, Sanavi Travels ensures a relaxed, enjoyable, and professionally managed travel experience, making corporate picnics in Pune memorable, well-coordinated, and hassle-free.',

    top: 'Corporate Picnic Travel Options in Pune',


"topPlaces": [
  {
    "title": "Office Team Outings",
    "description": "Cabs for corporate picnic in Pune are commonly used for office team outings where employees travel together to relax and unwind. Organized cab services ensure timely departures, comfortable seating, and smooth coordination, allowing teams to focus on bonding activities rather than travel concerns. Reliable transport helps maintain discipline and enhances the overall picnic experience."
  },
  {
    "title": "Corporate Resorts and Picnic Spots",
    "description": "Many corporate picnics are planned at resorts, farm stays, and picnic spots around Pune. Dedicated cab services ensure safe and comfortable travel on highways and rural roads, making group travel stress-free and enjoyable."
  },
  {
    "title": "Employee Engagement Activities",
    "description": "Employee engagement picnics often involve games, workshops, and team-building exercises. Well-managed cab services help employees arrive relaxed and energized, contributing to the success of engagement programs."
  },
  {
    "title": "Annual Corporate Get-Togethers",
    "description": "Annual corporate picnics and get-togethers require structured transport for large teams. Cab services ensure synchronized travel, punctual arrivals, and smooth return journeys."
  },
  {
    "title": "Management and Leadership Outings",
    "description": "Management and leadership outings require comfortable and premium travel arrangements. Sedans and SUVs provide privacy, comfort, and convenience for senior executives."
  },
  {
    "title": "Corporate Events and Outdoor Meetings",
    "description": "Outdoor meetings and informal corporate events held outside city limits rely on cab services for seamless travel. Organized transport ensures productivity and punctuality even in leisure settings."
  },
  {
    "title": "Family-Inclusive Corporate Picnics",
    "description": "Some corporate picnics include employee families. Spacious vehicles and flexible pickup options ensure safe and comfortable travel for all participants."
  },
  {
    "title": "One-Day Corporate Outings",
    "description": "One-day corporate picnics require efficient travel planning to maximize leisure time. Reliable cab services ensure minimal delays and smooth coordination."
  },
  {
    "title": "Adventure and Activity-Based Picnics",
    "description": "Adventure parks and activity zones around Pune are popular picnic destinations. Professional drivers and well-maintained vehicles ensure safe travel to such locations."
  },
  {
    "title": "Custom Corporate Picnic Routes",
    "description": "Custom picnic routes and multiple pickup points are easily managed with dedicated cab services, ensuring flexibility and convenience for diverse teams."
  }
]
,



"services": [
{
"name": "Cabs for Corporate Picnic in Pune",
"description": "Cabs for Corporate Picnic in Pune by Sanavi Travels provide a complete transportation solution for office outings, team picnics, and corporate leisure events. This service ensures safe, comfortable, and punctual group travel with professional drivers, flexible scheduling, and well-maintained vehicles, allowing companies to focus on enjoyment and team bonding."
},
{
"name": "Corporate Picnic Cab Hire Pune",
"description": "Corporate Picnic Cab Hire Pune offers organized cab services for companies planning picnic outings, ensuring smooth pickup, comfortable travel, and timely return."
},
{
"name": "AC Cab for Corporate Picnic Pune",
"description": "AC Cab for Corporate Picnic Pune ensures a cool and comfortable travel experience, especially during summer outings and long-distance picnic trips."
},
{
"name": "Non AC Cab for Corporate Picnic Pune",
"description": "Non AC Cab for Corporate Picnic Pune provides an economical travel option while maintaining safety, punctuality, and group coordination."
},
{
"name": "Sedan Cab for Corporate Picnic Pune",
"description": "Sedan Cab for Corporate Picnic Pune is ideal for small teams and management groups seeking efficient and comfortable travel."
},
{
"name": "SUV Cab for Corporate Picnic Pune",
"description": "SUV Cab for Corporate Picnic Pune supports larger groups and luggage requirements, offering enhanced comfort and space."
},
{
"name": "Cabs for Office Outing Pune",
"description": "Cabs for Office Outing Pune ensure organized travel for employees participating in office picnics and team outings."
},
{
"name": "Cabs for Team Outing Pune",
"description": "Cabs for Team Outing Pune provide safe and reliable transport for team-building events and informal corporate gatherings."
},
{
"name": "Affordable Corporate Picnic Cabs Pune",
"description": "Affordable Corporate Picnic Cabs Pune offer budget-friendly pricing with transparent billing, making outings cost-effective."
},
{
"name": "Best Corporate Picnic Cab Service Pune",
"description": "Best Corporate Picnic Cab Service Pune by Sanavi Travels is trusted for reliability, comfort, and professional coordination."
},
{
"name": "Corporate Picnic Cab with Driver Pune",
"description": "Corporate Picnic Cab with Driver Pune includes experienced drivers who ensure safe driving, punctuality, and courteous service."
},
{
"name": "Luxury Cabs for Corporate Picnic Pune",
"description": "Luxury Cabs for Corporate Picnic Pune deliver a premium travel experience for management and executive outings."
},
{
"name": "Cabs for Employee Outing Pune",
"description": "Cabs for Employee Outing Pune support large-scale employee participation with organized transport solutions."
},
{
"name": "Cabs for Corporate Events Pune",
"description": "Cabs for Corporate Events Pune manage transportation for outdoor corporate events, celebrations, and engagement programs."
},
{
"name": "Corporate Picnic Cab Rental Pune",
"description": "Corporate Picnic Cab Rental Pune provides flexible rental options for half-day, full-day, and customized picnic travel plans."
}
],
"tableData": [
["Corporate Picnic Cabs Pune", "Office Outing Cabs Pune"],
["Team Outing Cabs Pune", "Employee Picnic Transport"],
["Sedan Picnic Cab", "SUV Picnic Cab"],
["AC Picnic Cab", "Non AC Picnic Cab"],
["Affordable Picnic Cab", "Best Picnic Cab Service"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Expert Corporate Picnic Transport",
    "WhyChoosedescription": "Sanavi Travels specializes in managing corporate picnic transportation with professional planning and execution."
  },
  {
    "WhyChooseheading": "Comfortable and Safe Vehicles",
    "WhyChoosedescription": "Well-maintained vehicles ensure a smooth and comfortable picnic journey for all participants."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Experienced drivers ensure safe driving, punctuality, and courteous service throughout the trip."
  },
  {
    "WhyChooseheading": "Flexible Scheduling",
    "WhyChoosedescription": "Custom pickup points and return timings suit diverse corporate picnic plans."
  },
  {
    "WhyChooseheading": "Cost-Effective Packages",
    "WhyChoosedescription": "Transparent pricing helps companies manage outing budgets efficiently."
  },
  {
    "WhyChooseheading": "Support for All Group Sizes",
    "WhyChoosedescription": "From small teams to large corporate groups, suitable vehicles are available."
  },
  {
    "WhyChooseheading": "Stress-Free Coordination",
    "WhyChoosedescription": "Dedicated coordination ensures smooth logistics without travel-related hassles."
  },
  {
    "WhyChooseheading": "Trusted Corporate Partner",
    "WhyChoosedescription": "Sanavi Travels is trusted by corporates for reliable and enjoyable picnic transportation."
  }
]

}

const faqData = [
  {
    question: 'Do you provide cabs for corporate picnic in Pune?',
    answer: 'Yes, Sanavi Travels offers dedicated cab services for corporate picnics and office outings in Pune.'
  },
  {
    question: 'Are AC and Non AC cabs available for corporate picnic?',
    answer: 'Yes, both AC and Non AC cab options are available.'
  },
  {
    question: 'Can you manage large corporate picnic groups?',
    answer: 'Yes, we support transportation for small teams as well as large corporate groups.'
  },
  {
    question: 'Is driver included in picnic cab rental?',
    answer: 'Yes, all picnic cab rentals include a professional driver.'
  },
  {
    question: 'Can pickup and drop points be customized?',
    answer: 'Yes, we offer flexible pickup and drop locations as per corporate requirements.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Desai',
    feedback: 'Excellent cab arrangements for our corporate picnic. Very smooth and comfortable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Sanavi Travels handled our team outing transport perfectly. Highly recommended.',
    rating: 5
  }
];































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cabs for Corporate Picnic in Pune - Sanavi Travels",
  "description": "Sanavi Travels offers cabs for corporate picnics in Pune, including office outings, team outings, employee trips, and corporate events. AC and Non-AC sedans and SUVs are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};






  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Cabs for Corporate Picnic in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book cabs for corporate picnics in Pune with Sanavi Travels. AC & Non-AC sedans and SUVs for office outings, team outings, employee trips, and corporate events with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/259.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabsforcorporatepicnicinpune;